export enum TipoCliente {
    TodasOpcoes = 0,
    ConsumidorFinal = 1,
    EmpresaIsentaICMS = 2,
    EmpresaOptanteSimplesNacional = 3,
    EmpresaNaoOptanteSimplesNacional = 4,
    MicroEmpreendedorIndividual = 5,
}
